/* ss-atelier.js — semina i motivi da sarto e li tiene in movimento.
   Il respiro lo fa il css. Lo spostamento con lo scorrimento lo calcolo qui
   dentro un ciclo di frame: il tema Next a volte scorre dentro un contenitore
   suo e l'evento 'scroll' sulla finestra non arriva mai. */
(function () {
  var MOTIVI = {
    rocchetto: '<path d="M7 4h10"/><path d="M7 20h10"/><path d="M9 4v16"/><path d="M15 4v16"/><path d="M9 8h6"/><path d="M9 12h6"/><path d="M9 16h6"/>',
    metro: '<rect x="2" y="9" width="20" height="6" rx="1.5"/><path d="M6 9v3.4"/><path d="M10 9v4.4"/><path d="M14 9v3.4"/><path d="M18 9v4.4"/>',
    ago: '<path d="M3.2 20.8 16.6 7.4"/><circle cx="18.4" cy="5.6" r="2.1"/>',
    filo: '<path d="M2 14c2.6-6 5.4 6 8 0s5.4 6 8 0"/>',
    bottone: '<circle cx="12" cy="12" r="8"/><circle cx="9.4" cy="9.4" r="1"/><circle cx="14.6" cy="9.4" r="1"/><circle cx="9.4" cy="14.6" r="1"/><circle cx="14.6" cy="14.6" r="1"/>'
  };

  /* solo sulle fasce di testo: dove ci sono schede prodotto niente decorazione */
  var PIANO = [
    ['.ss-passi', [['ago', 'tr', 14], ['filo', 'bl', -11]]],
    ['.ss-conf',  [['bottone', 'tr', -12]]],
    ['.ss-bott',  [['metro', 'tr', 12]]],
    ['.ss-esca',  [['bottone', 'bl', -10]]],
    ['.ss-faq',   [['rocchetto', 'br', 11]]],
    ['.ss-cnt',   [['rocchetto', 'tr', 12], ['filo', 'bl', -9]]]
  ];

  var tutti = [];

  PIANO.forEach(function (riga, k) {
    var host = document.querySelector(riga[0]);
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    riga[1].forEach(function (m, i) {
      var el = document.createElement('span');
      el.className = 'ss-mot ss-mot--' + m[1] + (i > 0 ? ' ss-mot--sm-no' : '');
      el.setAttribute('aria-hidden', 'true');
      /* durate e ritardi diversi: due motivi che respirano all'unisono
         sembrano un errore, non una decorazione */
      el.style.setProperty('--d', (7.5 + ((k * 2 + i * 3) % 5) * 1.4).toFixed(1) + 's');
      el.style.setProperty('--r', (((k * 3 + i * 5) % 7) * 0.6).toFixed(1) + 's');
      el.innerHTML = '<span class="ss-mot__i"><svg viewBox="0 0 24 24">' + MOTIVI[m[0]] + '</svg></span>';
      host.appendChild(el);
      tutti.push({ el: el, host: host, v: m[2], vista: false });
    });
  });

  if (!tutti.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if ('IntersectionObserver' in window) {
    var oss = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        tutti.forEach(function (t) { if (t.host === v.target) t.vista = v.isIntersecting; });
      });
    }, { rootMargin: '250px' });
    var host = [];
    tutti.forEach(function (t) { if (host.indexOf(t.host) < 0) { host.push(t.host); oss.observe(t.host); } });
  } else {
    tutti.forEach(function (t) { t.vista = true; });
  }

  function frame() {
    if (document.visibilityState !== 'hidden') {
      for (var i = 0; i < tutti.length; i++) {
        var t = tutti[i];
        if (!t.vista) continue;
        var r = t.host.getBoundingClientRect();
        /* quanto e avanzata la fascia nello schermo, da circa -1 a 1 */
        var q = 1 - (r.top + r.height / 2) / (innerHeight / 2 + r.height / 2);
        t.el.style.transform = 'translate3d(0,' + (q * t.v).toFixed(1) + 'px,0)';
      }
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
